// extracted by mini-css-extract-plugin
module.exports = {"gift-dialog":"components_gift-dialog__5LPRX","gift-dialog-container":"components_gift-dialog-container__k2ShP","bg":"components_bg__JEnML","close":"components_close__e6ISE"};